/* 恵みの湯 リニューアルデザイン用スクリプト
 * 商品データはページ内（Liquid で出力した商品カード）を使い、外部APIは呼びません。
 */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = n => new Intl.NumberFormat('ja-JP').format(n);

  /* ---------- 検索・絞り込みの共通処理（見本の search.js を移植） ---------- */
  const Store = {
    normalize(s) {
      return String(s || '').normalize('NFKC').toLowerCase()
        .replace(/[ァ-ヶ]/g, c => String.fromCharCode(c.charCodeAt(0) - 96))
        .replace(/蓬/g, 'よもぎ').replace(/かみつれ/g, 'かもみーる')
        .replace(/贈りもの|贈り物|ぷれぜんと/g, 'ぎふと');
    },
    prices(card) {
      return (card.dataset.prices || '').split(',').filter(Boolean).map(Number);
    },
    inRange(card, min, max) {
      return this.prices(card).some(n => n >= min && n < max);
    },
    has(card, key, value) {
      return (card.dataset[key] || '').split('|').map(v => v.trim()).includes(value);
    },
    isGift(card) { return card.dataset.gift === '1'; },
    matches(card, query) {
      let q = this.normalize(query).replace(/(\d),(?=\d{3})/g, '$1');
      const ranges = [];
      q = q.replace(/(\d+)円台/g, (_, n) => { ranges.push([+n, +n + 1000]); return ' '; });
      if (!ranges.every(r => this.inRange(card, ...r))) return false;
      const hay = this.normalize(card.dataset.search);
      return q.split(/\s+/).filter(Boolean).every(t => {
        if (/^(20|30|40|50|60|70)代$/.test(t)) return this.isGift(card);
        if (t.includes('ぎふと')) return this.isGift(card) && t.split('ぎふと').filter(Boolean).every(w => hay.includes(w));
        return hay.includes(t);
      });
    },
    budgets: { under3000: [0, 3000], from3000: [3000, 5000], from5000: [5000, Infinity] },
    budgetNames: { under3000: '3,000円未満', from3000: '3,000〜4,999円', from5000: '5,000円以上' }
  };
  window.MegumiStore = Store;

  /* ---------- おすすめの商品（タブ＋キーワード） ---------- */
  function initCatalog(root) {
    const grid = $('.mgid-products', root);
    if (!grid || root.dataset.mgInit) return;
    root.dataset.mgInit = '1';
    const cards = $$('[data-mg-product]', grid);
    const input = $('.mgid-search', root);
    const result = $('.mgid-result', root);
    const empty = $('.mgid-empty', root);
    const siteSearch = $('.mg-site-search', root);
    const tabs = $$('.tabs [data-filter]', root);
    let filter = 'all';

    function render() {
      const q = input ? input.value.trim() : '';
      let count = 0;
      cards.forEach(card => {
        const ok = (filter === 'all' || card.dataset.tabs.includes('|' + filter + '|')) && Store.matches(card, q);
        card.hidden = !ok;
        if (ok) count++;
      });
      if (result) result.textContent = (q ? '「' + q + '」の検索結果：' : '') + count + '商品';
      if (empty) empty.hidden = count > 0;
      if (siteSearch) siteSearch.href = '/search?type=product&q=' + encodeURIComponent(q);
    }
    function select(value) {
      filter = tabs.some(b => b.dataset.filter === value) ? value : 'all';
      tabs.forEach(b => {
        const on = b.dataset.filter === filter;
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      render();
    }
    tabs.forEach(b => b.addEventListener('click', () => select(b.dataset.filter)));
    if (input) input.addEventListener('input', () => select('all'));
    root.mgSelectTab = value => { if (input) input.value = ''; select(value); };
    root.mgFocusSearch = () => input && input.focus({ preventScroll: true });

    const params = new URLSearchParams(location.search);
    const fromUrl = params.get('tab');
    if (fromUrl) select(fromUrl); else render();
    if (params.get('focus') === 'search' && input) setTimeout(() => input.focus({ preventScroll: true }), 300);
    const q = params.get('q');
    if (q && input) { input.value = q; input.dispatchEvent(new Event('input', { bubbles: true })); }
  }

  function catalogRoot() { return $('.mgid-catalog'); }

  function bindTabLinks() {
    document.addEventListener('click', e => {
      const link = e.target.closest('[data-mg-tab]');
      if (!link) return;
      const root = catalogRoot();
      if (!root || !root.mgSelectTab) return;
      e.preventDefault();
      root.mgSelectTab(link.dataset.mgTab);
      root.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  }

  /* ---------- ギフト選び ---------- */
  function initGifts(root) {
    const finder = $('[data-mg-gift-finder]', root);
    if (!finder || root.dataset.mgInit) return;
    root.dataset.mgInit = '1';
    const onlyGifts = finder.dataset.onlyGifts === '1';
    const cards = $$('[data-mg-product]', $('.mgid-gift-products', root));
    const fields = $$('[data-gift-filter]', finder);
    const budgetInput = $('[data-gift-filter=budget]', finder);
    const reset = $('.mgid-gift-reset', finder);

    function render() {
      const c = Object.fromEntries(fields.map(e => [e.dataset.giftFilter, e.value]));
      let count = 0;
      cards.forEach(card => {
        const range = Store.budgets[c.budget];
        const ok = (!onlyGifts || Store.isGift(card)) &&
          (!range || Store.inRange(card, ...range)) &&
          (c.recipient === 'all' || Store.has(card, 'recipients', c.recipient)) &&
          (c.occasion === 'all' || Store.has(card, 'occasions', c.occasion));
        card.hidden = !ok;
        if (ok) count++;
      });
      $('.mgid-gift-count', finder).textContent = count + '件のギフト';
      const labels = [Store.budgetNames[c.budget], c.recipient === 'all' ? '' : c.recipient, c.occasion === 'all' ? '' : c.occasion].filter(Boolean);
      $('.mgid-gift-summary', finder).textContent = labels.length ? labels.join(' ／ ') : 'すべてのギフト';
      reset.disabled = labels.length === 0;
      $$('[data-gift-budget]', finder).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.giftBudget === c.budget)));
      $('.mgid-gift-empty', root).hidden = count > 0;
      spLimit(labels.length > 0);
    }
    // スマホでは、絞り込みをしていないときは先頭4件だけ表示し、「もっと見る」で残りを開く
    const spQuery = matchMedia('(max-width: 600px)');
    const SP_LIMIT = 4;
    let expanded = false;
    const grid = $('.mgid-gift-products', root);
    const more = document.createElement('button');
    more.type = 'button';
    more.className = 'mg-sp-more';
    more.hidden = true;
    grid.after(more);
    more.addEventListener('click', () => { expanded = true; spLimit(false); });
    function spLimit(filtered) {
      const visible = cards.filter(card => !card.hidden);
      const limit = spQuery.matches && !expanded && !filtered;
      visible.forEach((card, i) => card.classList.toggle('mg-sp-over', limit && i >= SP_LIMIT));
      const rest = limit ? Math.max(0, visible.length - SP_LIMIT) : 0;
      more.hidden = rest === 0;
      more.textContent = 'ギフトをもっと見る（残り' + rest + '件）';
    }
    spQuery.addEventListener('change', render);
    fields.forEach(e => e.addEventListener('change', render));
    $$('[data-gift-budget]', finder).forEach(b => b.addEventListener('click', () => { budgetInput.value = b.dataset.giftBudget; render(); }));
    reset.addEventListener('click', () => { fields.forEach(e => { e.value = 'all'; }); render(); });
    render();
  }

  /* ---------- 条件から探す（価格・用途・効能） ---------- */
  function initFinder() {
    const grid = $('[data-mg-finder]');
    if (!grid || grid.dataset.mgInit) return;
    grid.dataset.mgInit = '1';
    const params = new URLSearchParams(location.search);
    const prices = { under1000: ['1,000円未満', 0, 1000], '1000to3000': ['1,000〜2,999円', 1000, 3000], '3000to5000': ['3,000〜4,999円', 3000, 5000], '5000plus': ['5,000円以上', 5000, Infinity] };
    const priceKey = params.get('price'), effect = params.get('effect'), occasion = params.get('occasion');
    const nav = $('[data-mg-finder-options]');
    const tpl = $('template[data-mg-occasion-options]');
    let occasionText = '';
    if (occasion && tpl) {
      nav.setAttribute('aria-label', 'ギフトの用途を選ぶ');
      nav.replaceChildren(tpl.content.cloneNode(true));
      const opt = $$('a', nav).find(a => a.dataset.value === occasion);
      occasionText = opt ? opt.dataset.text : '';
    }
    // 価格で探すときは価格の選択肢だけ、効能で探すときは効能の選択肢だけを表示
    if (!occasion) {
      const mode = effect ? 'effect' : 'price';
      $$('a', nav).forEach(a => { if (a.dataset.key !== mode) a.remove(); });
    }
    $$('a', nav).forEach(a => {
      const current = (a.dataset.key === 'price' && a.dataset.value === priceKey) ||
        (a.dataset.key === 'effect' && a.dataset.value === effect) ||
        (a.dataset.key === 'occasion' && a.dataset.value === occasion);
      if (current) a.setAttribute('aria-current', 'page');
    });
    const range = prices[priceKey];
    $('.mgid-finder-kind').textContent = occasion ? '用途で選ぶ' : effect ? '効能から探す' : range ? '価格から探す' : '条件から探す';
    $('.mgid-finder-title').textContent = occasion ? occasion + 'のギフト' : effect ? effect + 'で選ぶ' : range ? range[0] + 'の商品' : 'すべての商品';
    $('.mgid-finder-description').textContent = occasion ? (occasionText ? occasionText + ' ' : '') + grid.dataset.textOccasion : effect ? grid.dataset.textEffect : grid.dataset.textPrice;
    if (occasion || effect || range) document.title = $('.mgid-finder-title').textContent + ' | ' + document.title;
    let count = 0;
    $$('[data-mg-product]', grid).forEach(card => {
      const ok = occasion ? Store.isGift(card) && Store.has(card, 'occasions', occasion)
        : effect ? Store.has(card, 'effects', effect)
        : range ? Store.inRange(card, range[1], range[2]) : true;
      card.hidden = !ok;
      if (ok) count++;
    });
    $('.mgid-finder-count').textContent = count + '商品';
    $('.mgid-finder-empty').hidden = count > 0;
  }

  /* ---------- 商品詳細：バリエーション選択 ---------- */
  function initProduct(root) {
    if (!root || root.dataset.mgInit) return;
    root.dataset.mgInit = '1';
    const select = $('.mgid-product-variant', root);
    const qty = $('.mgid-product-quantity', root);
    const buy = $('.mgid-product-buy', root);
    const status = $('.mgid-variant-status', root);
    const price = $('.mgid-detail-price', root);
    const compare = $('.mgid-compare-price', root);
    const photo = $('.mgid-main-photo', root);
    const addLabel = buy ? buy.textContent : '';
    // 購入欄の追従位置（ヘッダーの高さ＋24px）。見本の product.js と同じ処理
    const header = $('.site-header');
    if (header) {
      const setTop = () => document.documentElement.style.setProperty('--purchase-top', (header.getBoundingClientRect().height + 24) + 'px');
      setTop();
      new ResizeObserver(setTop).observe(header);
    }
    function update(pushUrl) {
      const opt = select ? select.selectedOptions[0] : null;
      const available = opt ? opt.dataset.available === 'true' : buy.dataset.mgAvailable === 'true';
      const amount = qty ? qty.valueAsNumber : 1;
      const valid = Number.isInteger(amount) && amount >= 1 && amount <= 99;
      if (opt) {
        price.textContent = opt.dataset.price;
        if (compare) { compare.textContent = opt.dataset.compare || ''; compare.hidden = !opt.dataset.compare; }
        if (photo && opt.dataset.image) { photo.removeAttribute('srcset'); photo.src = opt.dataset.image; }
        if (pushUrl) {
          const url = new URL(location.href);
          url.searchParams.set('variant', opt.value);
          history.replaceState({}, '', url);
        }
      }
      status.textContent = !available ? '現在売り切れです' : !valid ? '数量を1〜99の整数で入力してください。' : '購入できます';
      const ok = available && valid;
      buy.disabled = !ok;
      buy.setAttribute('aria-disabled', String(!ok));
      buy.textContent = available ? addLabel || 'カートに入れる' : '売り切れ';
    }
    if (buy) buy.dataset.mgAvailable = String(!buy.disabled);
    if (!buy || !status) return;
    if (!select && buy.disabled) buy.textContent = '売り切れ';
    if (select) select.addEventListener('change', () => update(true));
    if (qty) qty.addEventListener('input', () => update(false));
    const form = buy.form;
    if (form) form.addEventListener('submit', e => { if (buy.disabled) e.preventDefault(); });
  }

  /* ---------- トップの左サイドバー ---------- */
  function initSidebar() {
    const sidebar = $('.mgid-store-sidebar');
    const toggle = $('.mgid-sidebar-toggle');
    if (!sidebar || !toggle || sidebar.dataset.mgInit) return;
    sidebar.dataset.mgInit = '1';
    const close = $('.mgid-sidebar-close', sidebar);
    function closeSidebar(restore) {
      sidebar.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (restore) toggle.focus();
    }
    toggle.addEventListener('click', () => {
      const open = !sidebar.classList.contains('is-open');
      sidebar.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      if (open && close) close.focus();
    });
    if (close) close.addEventListener('click', () => closeSidebar(true));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && sidebar.classList.contains('is-open')) closeSidebar(true); });
    $$('a', sidebar).forEach(a => a.addEventListener('click', () => {
      closeSidebar(false);
      $$('a', sidebar).forEach(x => x.removeAttribute('aria-current'));
      a.setAttribute('aria-current', 'true');
    }));
    const searchLink = $('.mgid-sidebar-search', sidebar);
    if (searchLink) searchLink.addEventListener('click', () => {
      const root = catalogRoot();
      if (root && root.mgFocusSearch) setTimeout(() => root.mgFocusSearch(), 50);
    });

    const header = $('.site-header');
    const footer = $('.site-footer');
    function updateTop() {
      const slider = $('.campaign-slider');
      const mobile = window.innerWidth <= 900;
      const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      const sliderBottom = slider ? slider.getBoundingClientRect().bottom : 0;
      const top = Math.max(0, mobile ? headerBottom : Math.max(headerBottom, sliderBottom));
      document.documentElement.style.setProperty('--header-height', top + 'px');
      if (mobile || sidebar.dataset.static) {
        sidebar.style.removeProperty('height');
        sidebar.style.removeProperty('bottom');
        sidebar.style.removeProperty('visibility');
        return;
      }
      const limit = Math.min(window.innerHeight, footer ? footer.getBoundingClientRect().top - 20 : window.innerHeight);
      const height = Math.max(0, limit - top);
      sidebar.style.height = height + 'px';
      sidebar.style.bottom = 'auto';
      sidebar.style.visibility = height > 0 ? 'visible' : 'hidden';
    }
    window.addEventListener('resize', updateTop);
    window.addEventListener('scroll', updateTop, { passive: true });
    window.addEventListener('load', updateTop);
    const ro = new ResizeObserver(updateTop);
    [$('main'), header, footer].filter(Boolean).forEach(el => ro.observe(el));
    updateTop();

    const menu = $('.mgid-menu');
    const mobileNav = $('.mgid-mobile-nav');
    if (menu && mobileNav) {
      menu.addEventListener('click', () => {
        mobileNav.hidden = !mobileNav.hidden;
        menu.setAttribute('aria-expanded', String(!mobileNav.hidden));
      });
      $$('a', mobileNav).forEach(a => a.addEventListener('click', () => { mobileNav.hidden = true; menu.setAttribute('aria-expanded', 'false'); }));
    }
  }

  /* ---------- 特集スライダー（見本の app.js を移植） ---------- */
  function initCampaign(root) {
    const track = $('[data-mg-campaign]', root);
    if (!track || track.dataset.mgInit) return;
    const slides = $$('.campaign-card', track);
    if (!slides.length) return;
    track.dataset.mgInit = '1';
    const dots = $$('[data-slide]', root);
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const playButton = $('.mgid-slide-autoplay', root);
    const autoplaySetting = playButton ? playButton.dataset.autoplay !== 'false' : true;
    for (const slide of slides) {
      const copy = slide.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.tabIndex = -1;
      copy.removeAttribute('data-shopify-editor-block');
      track.append(copy);
    }
    let slideIndex = 0, position = track.scrollLeft, lastTime = 0, paused = reducedMotion.matches || !autoplaySetting,
      hovered = false, touching = false, visible = true, holdUntil = 0, tween = null;
    const cycleWidth = () => track.children[slides.length].offsetLeft - slides[0].offsetLeft;
    function updatePlay() {
      if (!playButton) return;
      playButton.textContent = paused ? '再生' : '停止';
      playButton.setAttribute('aria-pressed', String(paused));
      playButton.setAttribute('aria-label', paused ? '自動スクロールを再生' : '自動スクロールを停止');
    }
    function showSlide(n) {
      const width = cycleWidth();
      if (!width) return;
      const index = (n + slides.length) % slides.length;
      position = ((track.scrollLeft % width) + width) % width;
      track.scrollLeft = position;
      const target = slides[index].offsetLeft - slides[0].offsetLeft;
      if (reducedMotion.matches) { position = target; track.scrollLeft = target; }
      else tween = { from: position, to: target, start: performance.now() };
      holdUntil = performance.now() + 4500;
    }
    function tick(now) {
      if (!track.isConnected) return;
      const delta = lastTime ? Math.min(now - lastTime, 50) : 0;
      lastTime = now;
      const width = cycleWidth();
      if (tween) {
        const t = Math.min((now - tween.start) / 1400, 1), ease = t * t * (3 - 2 * t);
        position = tween.from + (tween.to - tween.from) * ease;
        track.scrollLeft = position;
        if (t === 1) tween = null;
      } else if (width && !paused && !hovered && !touching && visible && !document.hidden && !track.contains(document.activeElement) && now > holdUntil) {
        position = (position + delta * 0.026) % width;
        track.scrollLeft = position;
      }
      requestAnimationFrame(tick);
    }
    track.addEventListener('scroll', () => {
      const width = cycleWidth();
      if (!width) return;
      const x = track.scrollLeft % width;
      let closest = 0;
      slides.forEach((slide, i) => {
        if (Math.abs(slide.offsetLeft - slides[0].offsetLeft - x) < Math.abs(slides[closest].offsetLeft - slides[0].offsetLeft - x)) closest = i;
      });
      slideIndex = closest;
      dots.forEach((b, i) => b.setAttribute('aria-pressed', String(i === slideIndex)));
      if (touching || hovered || paused || (performance.now() < holdUntil && !tween)) position = track.scrollLeft % width;
    }, { passive: true });
    track.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hovered = true; });
    track.addEventListener('pointerleave', () => { hovered = false; position = track.scrollLeft; lastTime = 0; });
    track.addEventListener('pointerdown', () => { touching = true; tween = null; });
    window.addEventListener('pointerup', () => { if (touching) { touching = false; position = track.scrollLeft; holdUntil = performance.now() + 3500; } });
    window.addEventListener('pointercancel', () => { touching = false; position = track.scrollLeft; });
    track.addEventListener('wheel', () => { tween = null; holdUntil = performance.now() + 3500; }, { passive: true });
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); showSlide(slideIndex + (e.key === 'ArrowRight' ? 1 : -1)); }
    });
    dots.forEach(b => b.addEventListener('click', () => showSlide(Number(b.dataset.slide))));
    const prev = $('.mgid-slide-prev', root), next = $('.mgid-slide-next', root);
    if (prev) prev.addEventListener('click', () => showSlide(slideIndex - 1));
    if (next) next.addEventListener('click', () => showSlide(slideIndex + 1));
    if (playButton) playButton.addEventListener('click', () => { paused = !paused; position = track.scrollLeft; lastTime = 0; updatePlay(); });
    reducedMotion.addEventListener('change', () => { paused = reducedMotion.matches; tween = null; updatePlay(); });
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; lastTime = 0; }).observe(track);
    window.addEventListener('resize', () => { tween = null; position = track.scrollLeft; lastTime = 0; });
    updatePlay();
    requestAnimationFrame(tick);
  }

  /* ---------- 紹介ページ：香りのボタンで購入欄のバリエーションを選ぶ ---------- */
  document.addEventListener('click', e => {
    const link = e.target.closest('[data-mg-variant]');
    if (!link) return;
    const select = $('.mgid-product-variant');
    const target = $('#mg-purchase');
    if (!select || !target) return;
    const opt = [...select.options].find(o => o.value === link.dataset.mgVariant);
    if (!opt) return;
    e.preventDefault();
    select.value = opt.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- 文字入り画像の横並びスライダー ---------- */
  function initHkSlider(root) {
    if (root.dataset.mgInit) return; root.dataset.mgInit = '1';
    const track = $('.hk-slider-track', root);
    const slides = $$('.hk-slide', track);
    const dots = $$('.hk-slider-dots span', root);
    if (!track || slides.length < 2) return;
    let index = 0, hold = false;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    function current() {
      const mid = track.scrollLeft + track.clientWidth / 2;
      let best = 0, dist = Infinity;
      slides.forEach((s, i) => { const c = s.offsetLeft + s.offsetWidth / 2; const d = Math.abs(c - mid); if (d < dist) { dist = d; best = i; } });
      return best;
    }
    function paint() { index = current(); dots.forEach((d, i) => d.classList.toggle('is-active', i === index)); }
    function go(i) {
      const s = slides[(i + slides.length) % slides.length];
      track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
    }
    track.addEventListener('scroll', () => window.requestAnimationFrame(paint), { passive: true });
    ['pointerenter', 'focusin', 'touchstart'].forEach(ev => track.addEventListener(ev, () => { hold = true; }, { passive: true }));
    ['pointerleave', 'focusout', 'touchend'].forEach(ev => track.addEventListener(ev, () => { hold = false; }, { passive: true }));
    const sec = Number(root.dataset.interval || 0);
    if (sec > 0 && !reduce) setInterval(() => { if (!hold && !document.hidden) go(index + 1); }, sec * 1000);
    paint();
  }

  /* ---------- 起動 ---------- */
  function initAll() {
    $$('.campaign-slider').forEach(initCampaign);
    $$('.mgid-catalog').forEach(initCatalog);
    $$('.mgid-gifts').forEach(initGifts);
    initFinder();
    $$('[data-mg-product-page]').forEach(initProduct);
    initSidebar();
    $$('[data-hk-slider]').forEach(initHkSlider);
    if (location.hash) {
      const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (target) setTimeout(() => target.scrollIntoView(), 0);
    }
  }
  bindTabLinks();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  // テーマエディタでセクションを編集したときに再初期化
  document.addEventListener('shopify:section:load', initAll);
})();
